export default "__VITE_ASSET__CeppVNRt__"